import { DateTime } from 'luxon';
import { DataRoomDocument } from './DataRoomDocument';
import { DataRoomFolder } from './DataRoomFolder';
import { CurrentUser } from './Users/CurrentUser';

export interface DataRoomDiligenceRequest {
	id: number;
	guid: string;
	title: string;
	details: string;
	resolution: string;
	isCompleted: boolean;
	createdOn: Date;
	completedOn?: Date | null;
	dataRoomUserGuid?: string | null;
	dataRoomUser?: string | null;
	lenderName?: string | null;
	bankName?: string | null;
	createdByGuid?: string | null;
	createdByUser?: string | null;
	updatedByUser?: string | null;
	isVisibleToAll: boolean;
	isWithdrawn: boolean;
	diligenceType: DiligenceRequestType;

	folder: DataRoomFolder;
	files: DiligenceRequestFile[];
	links: DiligenceRequestLink[];
}

export type DiligenceRequestType = keyof typeof DiligenceRequestTypeMap;
export const DiligenceRequestTypeMap = {
	DocumentRequest: 'Document Request',
	Question: 'Question',
};

export function CanAccessDiligenceRequestResolution(
	currentUser: CurrentUser,
	request?: DataRoomDiligenceRequest | null
): boolean {
	if (!request || !request.resolution || request.resolution == '') {
		return false;
	}

	if (currentUser.isBankUser) {
		return request.isCompleted;
	}

	return true;
}

export function ShowDiligenceRequestFiles(request?: DataRoomDiligenceRequest | null): boolean {
	const numberFiles: number = request?.files ? request.files.length : 0;
	const numberLinks: number = request?.links ? request.links.length : 0;

	return numberFiles > 0 || numberLinks > 0;
}

export interface DiligenceRequestFile {
	id: number;
	guid: string;
	title: string;
	fileName: string;
	createdOn: Date;
	fileSize: number;
}

export interface DiligenceRequestLink {
	id: number;
	guid: string;
	document: DataRoomDocument;
}

export interface StagedDiligenceRequestUpload {
	id: number;
	guid: string;
	createdOn: DateTime;
	fullName: string;
	diligenceType: DiligenceRequestType;
	items: StagedStagedDiligenceRequestUploadItem[];
}

export interface StagedStagedDiligenceRequestUploadItem {
	id: number;
	guid: string;
	title: string;
	folderName: string;
	details: string;
}
